import API from "serviceshift-ui/api-client";

export default {
  clearAppointment({ commit }) {
    commit("replace", {
      state: "appointment",
      data: null
    });
  },
  createAppointment(_, { link, payload }) {
    return API.makeRequest(link, {
      method: "POST",
      data: payload
    });
  },
  fetchAppointment({ commit }, id) {
    return API.makeRequest(`/v2/appointments/${id}`).then((res) => {
      commit("replace", {
        state: "appointment",
        data: res.data
      });
    });
  },
  cancelAppointment({ commit }, { id, reason }) {
    return API.makeRequest(`/v2/appointments/${id}/cancel`, {
      method: "PUT",
      data: {
        reason
      }
    }).then((res) => {
      commit("replace", {
        state: "appointment",
        data: res.data
      });
    });
  },
  updateAppointment({ commit }, { link, data }) {
    const { href, method } = link;
    return API.makeRequest(href, {
      method,
      data
    }).then((res) => {
      commit("replace", {
        state: "appointment",
        data: res.data
      });
    });
  },
  updateAppointmentStatus({ commit }, { link, params }) {
    const { href, method } = link;
    return API.makeRequest(href, {
      method,
      data: params
    }).then((res) => {
      commit("replace", {
        state: "appointment",
        data: res.data
      });
    });
  },
  updateAppointmentTimes({ commit }, { id, ...data }) {
    return API.makeRequest(`/v2/appointments/${id}/actual_times`, {
      method: "PUT",
      data: data
    }).then((res) => {
      commit("replace", {
        state: "job",
        data: res.data
      });
    });
  },
  async updateAppointmentStatusAndTimes(_, { link, params }) {
    const { href, method } = link;
    const res = await API.makeRequest(href, {
      method,
      data: params
    });
    return res.data;
  }
};
